<template>
    <VListItemIcon v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VListItemIcon>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item-icon';

export default {
    name: 'SrListItemIcon',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
